import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.refs.viewToggle?.addEventListener('click', this.#handleViewToggle);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.viewToggle?.removeEventListener('click', this.#handleViewToggle);
  }

  #handleViewToggle = () => {
    const isFullView = this.dataset.blogView === 'full';
    this.dataset.blogView = isFullView ? 'grid' : 'full';
    this.refs.viewToggle?.setAttribute('aria-pressed', String(!isFullView));

    if (this.refs.viewToggleText) {
      this.refs.viewToggleText.textContent = isFullView ? 'Full' : 'Grid';
    }
  };
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
